import { alpha, Theme } from '@mui/material/styles';

export default function OverridesTab(theme: Theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 46,
          color: theme.palette.text.primary,
          borderRadius: 4,
          '&:hover': {
            backgroundColor: theme.palette.primary?.lighter
              ? alpha(theme.palette.primary.lighter, 0.6)
              : 'rgba(0, 0, 0, 0.04)',
            color: theme.palette.primary?.main || theme.palette.text.primary,
          },
          '&:focus-visible': {
            borderRadius: 4,
            outline: `2px solid ${theme.palette.secondary?.dark || '#000'}`,
            outlineOffset: -3,
          },
        },
      },
    },
  };
}
